import { useLocation } from 'react-router-dom';

import {
  Table,
  TableBody,
  TableHeader,
  TableHead,
  TableRow
} from '@/components/ui/table';
import { Card } from '@/components/ui/card';
import { useUsers } from '@/data/user';

import UserRow from './UserRow';
import NotFound from '@/components/common/NotFound';

const UserList = () => {
  const location = useLocation();
  const params = new URLSearchParams(location.search);

  const users = useUsers(params);

  if (users.isLoading) {
    return null;
  }

  if (users.data?.length === 0) {
    return <NotFound title="No Users Found" />;
  }

  return (
    <>
      <Card>
        <Table>
          <TableHeader>
            <TableRow>
              <TableHead>Name</TableHead>
              <TableHead>Email</TableHead>
              <TableHead>Coach</TableHead>
              <TableHead>Joined</TableHead>
              <TableHead />
              <TableHead />
            </TableRow>
          </TableHeader>
          <TableBody>
            {users.data?.map((user) => (
              <UserRow key={user.id} user={user} />
            ))}
          </TableBody>
        </Table>
      </Card>
      <div className="text-center p-4">
        <span className="text-sm text-muted-foreground">
          Total: {users.data?.length}
        </span>
      </div>
    </>
  );
};

export default UserList;
